import { environment } from '../../../environments/environment';
import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
  AfterContentChecked,
  ChangeDetectorRef,
  HostListener,
  Renderer,
  Renderer2
} from '@angular/core';
import {
  Router,
  NavigationEnd
} from '@angular/router';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../services/common.service';
import { SSO } from './../../sso/sso.constants';
import { DataShareService } from '../services/data.service';
import { UserTitleType } from '../enums/user-title-type.enum';
import { CookieBannerType } from '../enums/cookie-banner-type';
import { Cart } from '../models/cart.model';
import { AppMessageService } from '../../app-message.service';
import { Subscription } from 'rxjs/Subscription';
import { CookieService } from 'ngx-cookie-service';
import { AppConstants } from '../../common/constants/app.constants';
import { CookieBannerResponse } from '../interfaces/cookie-banner-response.interface';
import { CookieBannerMessageType } from '../enums/cookie-message-types.enum';
import { CorporateNavigation } from '../enums/corporate-navigation.enum';
import { Member } from '../interfaces/member.interface';
import { CartSummary } from '../interfaces/cart-summary.interface';
import { CartTypes } from '../enums/cart-types.enum';
import { StoreConfig } from '../interfaces/store-config.interface';
import { Portal } from '../enums/document-type.enum';
import { MemberAllowedResources } from '../interfaces/member-allowed-resources.interface';
import { MemberType, MemberTitle } from '../enums/member-type.enum';
import { MemberLevel } from '../enums/member-level.enum';
import { ActiveSessionService } from '../services/active-session.service';
import { SponsorSearchRequest } from '../interfaces/sponsor-search-request.interface';
import { SponsorSearchOption } from '../enums';
import { SponsorSearchResponse } from '../interfaces/sponsor-search-response.interface';
import { ResponseStatus } from '../constants/response-status-constants';
import { SponsorInformation } from '../interfaces/sponsor-information.interface';
import { MapLocationInfo } from '../interfaces/map-location-info.interface';
import { SharedConstants } from '../constants/shared.constants';
import { PortalCountry } from '../interfaces/portal-country.interface';
import { Country, CountryUrlMetaData } from '../interfaces/country.interface';
import flatten from 'lodash-es/flatten';
import { HamburgerItemConstants, CountryUrlExtensionConstants } from '../constants';
import { ReportOnlyCountryService } from '../services/report-only-country.service';
import { AppCountryConfig } from 'src/app/app-country-config.interface';
import { MemberOrderRestrictionService } from '../services/member-order-restriction.service';
import { AppModalDirective } from 'src/app/common/directives/app-modal.directive';
import { AppConfigService } from 'src/app/app-config.service';
import { MemberOrderRestrictionInfo } from '../interfaces/member-order-restriction-info.interface';
import { NotificationService } from '../services/notification.service';
import { NotificationType } from 'src/app/common/enums/notification-type.enum';
import { TranslateService } from '@ngx-translate/core';

declare var canShowSplashInitally: any;

@Component({
  selector: 'app-header',
  templateUrl: '../templates/template1/views/new-app-header.component.html',
  styleUrls: ['../templates/template1/themes/default/less/new-app-header.less']
})
export class AppHeaderComponent implements OnInit, OnDestroy, AfterContentChecked {
  @ViewChild('contactUS', { static: false }) public contactUS: ElementRef;
  @ViewChild('countryLanguageSelection', { static: false }) public countryLanguageSelection: ElementRef;
  @ViewChild('memberOrderRestrictionModal', { static: false }) public memberOrderRestrictionModal: AppModalDirective;
  enrollLogout: Subscription;
  wishListSubscription: Subscription;
  eventSubscription: any;
  searchCountry = '';
  canLoadSplashScreenInitally: any;
  userInfo: Member;
  topNav = true;
  isShowSearch = false;
  category: any = {};
  selectedLanguage: string;
  defaultLanguage: string;
  homeRoute: string;
  selectedCountry: any;
  isSplashScreenShown = false;
  selectedLanguageName: string;
  hideLogin = false;
  countryLangSettings: any;
  loggedIN: boolean;
  userName = '';
  cookieBannerValue: boolean;
  isCollapsed = false;
  isJoinMenuCollapsed = false;
  public notificationsOptions = {
    position: ['top', 'right'],
    lastOnBottom: true
  };
  myCountries: any = [];
  hideCart = false;
  openCart = false;
  showMenu = false;
  showMiniCart: boolean;
  cartSubscription: Subscription;
  cartItemsCount = 0;
  isoCountryCode: string;
  customerName: string = environment.customerName;
  s3BucketUrl: string = environment.cdnURL;
  memberTitle = MemberLevel;
  memberTitleId: number = MemberLevel.RETAIL;
  userTitle: string;
  isCollapsedSubscription: Subscription;
  // wqa
  showDropDown: boolean;
  loggedInUser: Member;
  isForceCollapse = false;
  cookieService: CookieService = new CookieService(document);
  wishlistItemsCount = 0;
  showHeaderMenu = false;
  languageCode: string;
  isImpersonatedUser: boolean;
  scrollRetainPos = 0;
  @ViewChild('globalheader', { static: false }) public globalHeader: ElementRef;
  @ViewChild('lnkShop', { static: false }) public _lnkShop: ElementRef;
  appHeaderHeight: any;
  showMobileNav: boolean;
  hamburgerToggleItem: any = {};
  profileImageURL: string;
  corporateNavigation = CorporateNavigation;
  isAccountMenuHover = false;
  isEnableWishList: boolean;
  storeData: StoreConfig;
  memberAllowedResources: MemberAllowedResources[] = [];
  prevScrollPosition: number;
  isFramedLoaded: boolean;
  maxLandscapeHeight = 480;
  shareFBOID: string;
  showShareFBODetail: boolean;
  memberInformation: Member;
  memberTypes = MemberType;
  showMyRetailSite = false;
  showMyRetailSiteEmail = false;
  showMyRetailSitePhone = false;
  showTopMenu = false;
  removeMyRetailSite = true;
  sponsorPollCount = 0;
  sponsorMaxPollCount = environment.longPollCount;
  isAboutMenuCollapsed = false;
  mapLocation: MapLocationInfo;
  bottomHeaderHeight: number;
  betaCountry = false;
  displayBetaPortalNotification = false;
  betaVisualCuetranslationValues: any;
  selectedPortalCountry: Country;
  appCountryConfig: AppCountryConfig;
  memberOrderRestrictionInfo: MemberOrderRestrictionInfo;
  loadMemberOrderRestrictionInfo = false;
  memberOrderRestrictionInfoSubscription: Subscription;
  restrictOrderNotificationSubscription: Subscription;
  showFPCMenu: boolean;
  showFBOMenu: boolean;

  constructor(
    private _commonService: CommonService,
    private _router: Router,
    private _cacheService: CacheService,
    private router: Router,
    private _cdf: ChangeDetectorRef,
    private _dataService: DataShareService,
    private _appMessageService: AppMessageService,
    private _activeSessionService: ActiveSessionService,
    private renderer: Renderer2,
    private _reportOnlyCountryService: ReportOnlyCountryService,
    private memberOrderRestrictionService: MemberOrderRestrictionService,
    private appConfigService: AppConfigService,
    private _translatePipe: TranslateService,
    private _notificationService: NotificationService
  ) {
    this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
    this.homeRoute = './';
    // hide the searchbox other than shop
    this.eventSubscription = this._router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.isShowSearch = this._router.url.split('/').indexOf('shop') > -1 && !(this._router.url.indexOf('shop/') > -1);
        const accessToken = SSO.isRemoveObsoleteCookie() ? localStorage.getItem(SSO.ACCESS_TOKEN)
          : this.cookieService.get(SSO.ACCESS_TOKEN);
        if (!accessToken) {
          //     if (!this.cookieService.get(SSO.ACCESS_TOKEN)) {
          if (Boolean(this._cacheService.get(CacheKey.GuestUser))) {
            this.hideLogin = true;
          }
        }
        // FBO flyout display changes
        const memberInformation = this._cacheService.get(CacheKey.ShareFBODetails);
        if (memberInformation) {
          this.memberInformation = memberInformation;
          setTimeout(() => {
            this.showShareFBODetail = true;
            this.showTopMenu = true;
            this.removeMyRetailSite = false;
          }, 3000);
        }
      }
    });
  }

  ngOnInit() {
    this.canLoadSplashScreenInitally = canShowSplashInitally;
    this.cookieBannerValue = this._cacheService.get(CacheKey.CookieBanner);
    this.countryLangSettings = this._cacheService.get(CacheKey.CountryLangSettings);
    this.getSSOData();
    this.storeData = this._cacheService.get(CacheKey.StoreConfiguration);
    this.isEnableWishList = this.storeData ? this.storeData.enableWishlist : false;
    this.loggedInUser = this._cacheService.get(CacheKey.UserInfo);
    this.getUserTitle();
    // Collapse menu subscription
    this.isCollapsedSubscription = this._appMessageService.getCollapseMenu()
      .subscribe((isOpen: boolean) => {
        this.isCollapsed = isOpen;
        this.isAboutMenuCollapsed = isOpen;
        this.showMobileNav = isOpen;
        this.setBodyFixed(this.showMobileNav);
        this.isForceCollapse = true;
      });
    this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
    this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    this.configureBetaPortalFlags();
    this.fillInTranslationValues();
    this.enrollLogout = this._appMessageService.getNotifyLoginStatus().subscribe((isLogin: boolean) => {
      if (isLogin) {
        this.login();
      }
      // tslint:disable-next-line:one-line
      else {
        this.logout();
      }
    });
    this.showSearchBox(false);
    this._appMessageService.isSearchBoxVisibile().subscribe((canShow: boolean) => {
      this.isShowSearch = canShow;
    });
    this.getWishListSubject();
    if (this.userInfo && this.userInfo.memberType) {
      this.getMemberAllowedResources();
    }
    this.shareFBOID = this._cacheService.getSessionValue(CacheKey.fboId);
    if (this.shareFBOID &&
      ((!this.userInfo) || (this.userInfo && this.userInfo.memberTypeId === MemberType.RETAILCUSTOMER))
      && (window.location.href.indexOf('/ordersummary') < 0)) {
      const memberInformation = this._cacheService.get(CacheKey.ShareFBODetails);
      if (memberInformation) {
        this.memberInformation = memberInformation;
        this.removeMyRetailSite = false;
        this.showTopMenu = true;
      } else {
        this.getMemberDetails();
      }
    }
    this.appCountryConfig = this.appConfigService.getSettings(this.isoCountryCode);
    this.getMemberOrderRestrictionEventSubscription();
    this.validateUserByRestrictOrderRule();
    this.getMapLocation();
    if (environment.allCountriesCorporateEnabled) {
      this.selectedPortalCountry = this.getPortalCountry();
      if (this.selectedPortalCountry && !this.selectedPortalCountry.titanPlatformEnabled) {
        this.hideCart = true;
      }
    }
  }


  /**
  * display member order rule restriction popup for UK FBO when user clicks on add to bag
  * getRestrictOrderNotificationSubscription()
  * @memberof AppHeaderComponent
  */
  getRestrictOrderNotificationSubscription(): void {
    this.restrictOrderNotificationSubscription = this._appMessageService.getShowRestrictOrderNotificationSubject().subscribe(response => {
      this.memberOrderRestrictionModal.show();
    });
  }

  /**
  * get member Order restriction event subscriotion
  * getMemberOrderRestrictionEventSubscription()
  * @memberof AppHeaderComponent
  */
  getMemberOrderRestrictionEventSubscription(): void {
    this.memberOrderRestrictionInfoSubscription = this._appMessageService.getMemberOrderRestrictionInfoSubject().subscribe(response => {
      if (!this.loadMemberOrderRestrictionInfo) {
        this.validateUserByRestrictOrderRule();
      }
    });
  }

  /**
  * display member order rule restriction message for UK FBO
  * validateUserByRestrictOrderRule()
  * @memberof AppHeaderComponent
  */
  validateUserByRestrictOrderRule(): void {
    const userInfo: Member = this._cacheService.get(CacheKey.UserInfo);
    const memberOrderRestrictionInfo = this.memberOrderRestrictionService.getOrderRestrictionsInfo();
    if (this.appCountryConfig.restrictOrder && userInfo && userInfo.memberTypeId === MemberType.DISTRIBUTOR
      && memberOrderRestrictionInfo) {
      this.loadMemberOrderRestrictionInfo = true;
      const memberOrderRestrcitionInfo = this.memberOrderRestrictionService.validateUserByRestrictOrderRule();
      if (memberOrderRestrcitionInfo && memberOrderRestrcitionInfo.memberOrderRestricted) {
        this.memberOrderRestrictionInfo = memberOrderRestrcitionInfo;
        this.getRestrictOrderNotificationSubscription();
      }
    }
  }

  /**
  * close memberOrder Restriction Popup
  * closeMemberOrderRestrictionPopup()
  * @memberof AppHeaderComponent
  */
  closeMemberOrderRestrictionPopup(): void {
    this.memberOrderRestrictionModal.hide();
  }

  /**
  * show memberOrder Restriction Popup
  * showRestrictOrderNotificationModal()
  * @memberof AppHeaderComponent
  */
  showRestrictOrderNotificationModal(): void {
    this.memberOrderRestrictionModal.show();
  }

  /**
   * Added comments
   */
  configureBetaPortalFlags() {
    if (environment.betaPortal) {
      if (this._commonService.betaCountry(this.isoCountryCode)) {
        this.betaCountry = true;
        this.displayBetaPortalNotification = true;
      } else {
        this.updateBetaPortalFlagForPreviewPortals(this.isoCountryCode);
      }
    }
  }

  /**
   *
   * @param countryCode
   */
  updateBetaPortalFlagForPreviewPortals(countryCode: string) {
    const portalCountries: PortalCountry[] = this._cacheService.get(CacheKey.PortalCountries);
    if (portalCountries !== null && portalCountries !== undefined && portalCountries.length > 0) {
      this.toogleBetaNotificationFlag(portalCountries, countryCode);
    } else {
      this._commonService.getPortalCountries().subscribe((portalCountriesResponse: PortalCountry[]) => {
        if (portalCountriesResponse && portalCountriesResponse.length > 0) {
          this.toogleBetaNotificationFlag(portalCountriesResponse, countryCode);
        }
      });
    }
  }
  /**
   * 
   * @param portalCountries 
   * @param countryCode 
   */
  toogleBetaNotificationFlag(portalCountries: PortalCountry[], countryCode: string) {
    if (portalCountries !== null && portalCountries !== undefined && portalCountries.length > 0) {
      let countries = flatten(
        portalCountries.map(portal => portal.countries));
      const country: Country = countries.find(item => item.isocodeThree.toLowerCase() ===
        this.isoCountryCode.toLowerCase());
      if (country) {
        this.betaCountry = country.titanPlatformEnabled ? false : true;
        this.displayBetaPortalNotification = true;
      }
    }
  }

  /**
   * Fill in the Visual cue changes in BETA portals
   */
  fillInTranslationValues() {
    this.betaVisualCuetranslationValues = {
      isoCountryCode: this.isoCountryCode.toUpperCase()
    }
  }

  /**
     * In chrome and some browser scroll is given to body tag
     * @param  {any} $event
     */
  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event: any) {
    const deviceViewportHeight = document.body.clientHeight;
    if (deviceViewportHeight < this.maxLandscapeHeight
      && !this.isFramedLoaded && !this.isCollapsed && !this.isJoinMenuCollapsed && !this.isAboutMenuCollapsed
      && !this._appMessageService.isBodyScrolling) {
      // to avoid flicker while scrolling
      // it will be executed when the scroll has been stopped
      requestAnimationFrame(() => {
        const scrollTop = (document.documentElement.scrollTop || document.body.scrollTop);
        // scroll Up
        if (scrollTop > this.prevScrollPosition) {
          this.topNav = false;
        } else { // scroll Down
          this.topNav = true;
        }
        this.prevScrollPosition = scrollTop < 0 ? 0 : scrollTop;
        this.isFramedLoaded = false;
      });
      this.isFramedLoaded = true;
    } else {
      this.topNav = true;
    }
  }
  /**
   * @description
   * @date 2019-02-14
   * @private
   * @memberof AppHeaderComponent
   */
  private getUserTitle(): void {
    this.memberTitleId = this._activeSessionService.getMemberTitleId();
    if (this.userInfo) {
      this.userTitle = this.userInfo.memberTitle;
    }
    if (this.userInfo && this.userInfo.memberTypeId === MemberType.PREFERREDCUSTOMER) {
      this.userTitle = MemberTitle.FPC;
    }
    if (this.userInfo && this.userInfo.memberTypeId === MemberType.RETAILCUSTOMER) {
      this.userTitle = MemberTitle.RETAIL;
    }
    if (this.userTitle) {
      if (this.userInfo) {
        const notWholesaleQualifiedFBO = this.userInfo.memberTypeId === MemberType.DISTRIBUTOR && (!this.userInfo.wholesaleQualified || this.userInfo.memberTitleId === MemberLevel.NOVUSCUSTOMER);
        this.showFPCMenu = this.userInfo.memberTypeId === MemberType.PREFERREDCUSTOMER || notWholesaleQualifiedFBO ; // show only reports menu in black bar
        this.showFBOMenu = this.userInfo.memberTypeId === MemberType.DISTRIBUTOR && this.userInfo.wholesaleQualified && this.userInfo.memberTitleId < MemberLevel.NOVUSCUSTOMER; // show all the menu in black bar
      }
    } else {
      this._cacheService.remove(CacheKey.WishListSession);
    }
  }

  /**
   *Get Member Allowed Resources and Maps the field
  *
  * @memberof MyAccountNavigationComponent
  */
  getMemberAllowedResources() {
    this._commonService
      .getMemberAllowedResources(this.userInfo.memberType)
      .subscribe(memberPrivileges => {
        if (memberPrivileges) {
          this.memberAllowedResources = this._commonService.prepareLeftMenuNavigation(memberPrivileges, this.isImpersonatedUser);
        }
      });
  }

  ngAfterContentChecked(): void {
    this._cdf.detectChanges();
    this.appHeaderHeight = this.globalHeader.nativeElement.offsetHeight;
    //const conutrySelectionHeight = this.countryLanguageSelection && this.countryLanguageSelection.nativeElement.offsetHeight || 0;
    const contactUSHeight = this.contactUS && this.contactUS.nativeElement.offsetHeight || 0;
    this.bottomHeaderHeight = contactUSHeight;
  }
  /**
      * to make background unaccessible while collapsible shown
      * @param  {boolean} setFixed
      * @returns void
      */
  setBodyFixed(setFixed: boolean): void {
    this._appMessageService.isBodyScrolling = true;
    if (setFixed) {
      // document.body.style.overflow = 'hidden';
      // document.documentElement.style.overflow = "hidden";
      this.scrollRetainPos = document.documentElement.scrollTop || document.body.scrollTop;
      document.body.style.position = 'fixed';

    } else {
      document.body.style.position = 'static';
      this._commonService.scrollByValue(0, this.scrollRetainPos, 0);
      this._appMessageService.isBodyScrolling = false;
      // document.body.style.overflow = 'initial';
      // document.documentElement.style.overflow = "initial";
    }
  }

  /**
   * Hide Cookie Banner
   */
  hideCookie() {
    this._cacheService.set(CacheKey.CookieBanner, 'false');
  }

  /**
   * Event trigger on updating wishlist items
  * @returns void
  */
  getWishListSubject(): void {
    this.wishListSubscription = this._appMessageService.getWishListItems()
      .subscribe(response => {
        this.getWishlistProducts();
      });
  }

  /**
  * to display wishlist products
  */
  getWishlistProducts() {
    const wishListCart = this._cacheService.get(CacheKey.WishListSession);
    if (wishListCart) {
      this.wishlistItemsCount = wishListCart.items && wishListCart.items.length ? wishListCart.items.length : 0;
    } else {
      const cartSummary: CartSummary[] = this._cacheService.get(CacheKey.CartSummary);
      if (cartSummary && cartSummary.length > 0) {
        const wishlistCart = cartSummary.find(x => x.cartTypeId === CartTypes.WishlistCart);
        if (wishlistCart) {
          this.wishlistItemsCount = wishlistCart.itemCount;
        }
      }
    }
  }

  /**
   * to get keycloak data for sso
   */
  getSSOData() {
    const accessToken = SSO.isRemoveObsoleteCookie() ? localStorage.getItem(SSO.ACCESS_TOKEN) : this.cookieService.get(SSO.ACCESS_TOKEN);
    if (accessToken) {
      this.loggedIN = true;
      this.getUserData();
    } else {
      this.loggedIN = false;
    }
  }

  openMiniCart(isOpen: boolean): void {
    // this._sharedMessageService.setOpenCart(!isOpen);
  }

  /**
   * hide header data
   * @param template
   */
  hideHeader(template: any): void {
    if (template.nextElementSibling !== undefined) {
      template.style.display = 'block';
    } else {
      template.style.display = 'none';
    }
  }

  /**
   * Get userinfo
   */
  getUserData(): void {
    this.userInfo = this._cacheService.get(CacheKey.UserInfo);
    this.isImpersonatedUser = this._cacheService.get(CacheKey.ImpersonatedUser);
    this.userName = this.userInfo.firstName;
    this.profileImageURL = this._commonService.encodeImageURL(this.userInfo.profileImageURL) || AppConstants.DEFULT_PROFILEIMG;
  }

  /**
   *
   */
  private getPortalCountry(): Country {
    const portalCountries: PortalCountry[] = this._cacheService.get(CacheKey.PortalCountries);
    if (portalCountries && portalCountries.length > 0) {
      const countries = flatten(
        portalCountries.map(portal => portal.countries));
      const country: Country = countries.find(item => item.isocodeThree.toLowerCase() ===
        this.isoCountryCode.toLowerCase());
      if (country) {
        return country;
      }
    }
  }

  /**
   */
  private validateNonTitanCountryNavigation(country: Country, item: string) {
    if (country && !country.titanPlatformEnabled && environment.allCountriesCorporateEnabled) {
      let url = '';
      url = this._commonService.getCountryConfigurationURL(country, item);
      const countryURLMetaData: CountryUrlMetaData = country.urlMetadata && country.urlMetadata.length ?
        country.urlMetadata.find(x => x.portal.toLowerCase() === item.toLowerCase()) : null;
      if (url && countryURLMetaData) {
        if (country && !country.titanPlatformEnabled &&
          this.userInfo && this.userInfo.memberAllowedCountries && this.userInfo.memberAllowedCountries.length > 0
          && item === CountryUrlExtensionConstants.SHOP) {
          this.navigateToLegacy(country, url, countryURLMetaData);
        } else {
          this.navigateByConfiguredURL(country, url, countryURLMetaData);
        }
      } else if (url) {
        window.open(url, '_blank');
      } else {
        this.router.navigateByUrl('/' + country.isocodeThree.toLowerCase() + '/' + this.languageCode.toLowerCase()
          + '/contact-forever-living');
      }
    }
  }

  navigateToLegacy(country: Country, url: string, countryURLMetaData: CountryUrlMetaData): void {
    const memberAllowedCountry = this.userInfo.memberAllowedCountries
      .find(item => item.isoCodeThree === country.isocodeThree);
    if (memberAllowedCountry) {
      this._commonService.navigateToLegacy(country.isocodeThree).subscribe(response => {
        if (response) {
          let url = decodeURIComponent(encodeURIComponent(response.redirectUrl +
            '?store=' + response.store + '&idtoken=' + response.idToken));
          window.open(url, '_blank');
        }
      });
    }
  }

  /**
   * This method used to navigate by configured url
   * navigateToConfiguredURL()
   */
  navigateByConfiguredURL(country: Country, url: string, countryURLMetaData: CountryUrlMetaData): void {
    switch (countryURLMetaData.urlExtention) {
      case CountryUrlExtensionConstants.LEGACY:
        url = url + '&language=' + (this.languageCode ? this.languageCode.split('-')[0] : 'en');
        url = this._commonService.appendFBOID(url, true);
        window.open(url, countryURLMetaData.target);
        break;
      case CountryUrlExtensionConstants.CONTACT_FOREVERE_LIVING:
        url = '/' + country.isocodeThree.toLowerCase() + '/' + this.languageCode.toLowerCase() + '/contact-forever-living'
        this.router.navigateByUrl(url);
        break;
      case CountryUrlExtensionConstants.PDF:
        url = environment.cdnURL + '/' + url;
        window.open(url, countryURLMetaData.target);
        break;
      default:
        window.open(url, countryURLMetaData.target);
        break;
    }
  }

  /**message service to product search component that shows search box
  * @returns void
  */
  showSearchBox(value: boolean, $event?: any): void {
    this._appMessageService.setSearchBoxVisibility(value);
    if (value) {
      setTimeout(() => {
        this._commonService.focusTargetElement('search-input');
      }, 0);
    }
    if (this.isCollapsed) {
      this.isCollapsed = false;
    }
    if (this.isJoinMenuCollapsed) {
      this.isJoinMenuCollapsed = false;
    }
    this.isAboutMenuCollapsed = false;
  }

  // setting value from the product search
  public setSearch(value: boolean) {
    this.isShowSearch = value;
    this.showMobileNav = false;
    this.setBodyFixed(this.showMobileNav);
  }

  /**
  * To navigare to other modules
  * @param  {string} moduleName
  * @returns void
  */
  navigateToModule(siteUrl: string): void {
    const languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    window.location.href = siteUrl + '&languageCode=' + languageCode.toLowerCase();
  }

  /**Toggle DropDown view */
  toogleDropDown() {
    this.showDropDown = !this.showDropDown;
  }

  /**
   * Navigate to internal Linka
   * @param menuItem
   */
  navigateToInternalLink(menuItem: any): void {
    const languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    if (menuItem.sitemapId) {
      this._router.navigate(['/' + this.isoCountryCode.toLowerCase() + '/' + languageCode.toLowerCase(),
      { queryParams: { sitemapId: menuItem.sitemapId } }]);
    }
  }
  /**
   * keyclock login
   * @returns void
   */
  login(): void {
    if (SSO.isRemoveObsoleteCookie()) {
      localStorage.removeItem(SSO.ACCESS_TOKEN);
      localStorage.removeItem(SSO.REFRESH_TOKEN);
      localStorage.removeItem(SSO.LOCAL_MEMBER_SESSION_ID);
      localStorage.removeItem(SSO.IS_NEW_TOKEN);
      this.cookieService.delete(SSO.MEMBER_SESSIONID, environment.cookiePath, environment.cookieDomain);
      this.cookieService.delete(SSO.MEMBER_SESSION_STATE, environment.cookiePath, environment.cookieDomain);
    } else {
      this.cookieService.delete(SSO.ACCESS_TOKEN, environment.cookiePath, environment.cookieDomain);
      this.cookieService.delete(SSO.REFRESH_TOKEN, environment.cookiePath, environment.cookieDomain);
      this.cookieService.delete(SSO.MEMBER_SESSION_STATE, environment.cookiePath, environment.cookieDomain);
    }
    const returnUri: string = window.location.pathname + window.location.search;
    if (!returnUri.includes(SharedConstants.LegacyUrlWhitelistPhrase)) {
      this._cacheService.set(CacheKey.Nav_path, returnUri);
    }
    const shoppingCart: Cart = this._cacheService.get(CacheKey.CartSessionInfo);
    let cartSessionGuid = null;
    const userInfo = this._cacheService.get(CacheKey.UserInfo);
    if (shoppingCart && shoppingCart.sessionGuid && !userInfo) {
      cartSessionGuid = shoppingCart.sessionGuid;
    }
    let redirectToFav = false;
    if (this._cacheService.get(CacheKey.RedirectToFavourites)) {
      this._cacheService.remove(CacheKey.RedirectToFavourites);
      redirectToFav = true;
    }
    this._commonService.updateCountryCodeinCookie();
    const redirectURL = SSO.getSSOLoginUrl(this.selectedLanguage, cartSessionGuid, redirectToFav, environment.accountSiteURL) + '&chc=false';
    window.location.href = redirectURL;
  }


  /**
   * toggle Menu
   */
  toggleMenu(isJoinMenu?: boolean, isAboutMenu?: boolean) {
    const country = this.getPortalCountry();
    const selectedMenu = isJoinMenu ? HamburgerItemConstants.JOIN :
      isAboutMenu ? HamburgerItemConstants.ABOUT : HamburgerItemConstants.SHOP;
    const countryURLMetaData: CountryUrlMetaData = country && country.urlMetadata && country.urlMetadata.length ?
      country.urlMetadata.find(x => x.portal.toLowerCase() === selectedMenu.toLowerCase()) : null;
    if (country && !country.titanPlatformEnabled && environment.allCountriesCorporateEnabled
      && ((countryURLMetaData && !countryURLMetaData.navigationMenu) || (!countryURLMetaData))) {
      this.validateNonTitanCountryNavigation(country, selectedMenu);
    }
    else if (this._reportOnlyCountryService.reportOnlyCountry(this.isoCountryCode) &&
      ((countryURLMetaData && !countryURLMetaData.navigationMenu) || (!countryURLMetaData))) {
      this.reportOnlyCountryNavigation(country, selectedMenu);
    }
    else {
      if (isJoinMenu) {
        this.isJoinMenuCollapsed = !this.isJoinMenuCollapsed;
      } else if (isAboutMenu) {
        this.isAboutMenuCollapsed = !this.isAboutMenuCollapsed;
      } else {
        this.isCollapsed = !this.isCollapsed;
      }
      this.isSplashScreenShown = false;
    }
  }

  private reportOnlyCountryNavigation(country: Country, selectedMenu: string) {
    let urlConfig = this._reportOnlyCountryService.reportOnlyCountryNavigationUrl(country, selectedMenu);
    if (urlConfig) {
      if (urlConfig.target === '') {
        this._router.navigateByUrl(urlConfig.url);
        return;
      }
      else {
        window.open(urlConfig.url, urlConfig.target);
        return;
      }
    }
  }


  joinMenuCollapsed(eventValue: boolean): void {
    this.isJoinMenuCollapsed = eventValue;
  }

  onShopHoverEscapeClicked() {
    this.isCollapsed = false;
    let inputField: HTMLElement = <HTMLElement>document.querySelectorAll('#lnkShop')[0];
    inputField && inputField.focus();
  }

  onJoinHoverEscapeClicked() {
    this.isJoinMenuCollapsed = false;
    this.isCollapsed = false;
    let inputField: HTMLElement = <HTMLElement>document.querySelectorAll('#lnkJoin')[0];
    inputField && inputField.focus();
  }

  onCountrySelectionHoverEscapeClicked() {
    console.log('country language selection triggered');
    let inputField: HTMLElement = <HTMLElement>document.querySelectorAll('#countryLanguageSelection')[0];
    inputField && inputField.focus();
  }

  /**
   * hide mini cart
   * @return void
   */
  hideMiniCart() {
    this.showMiniCart = false;
  }

  /**
   * @description
   * @date 2018-10-27
   * @param {boolean} isOpen
   * @memberof AppHeaderComponent
   */
  showAccountMenu(isOpen: boolean) {
    if (!isOpen) {
      setTimeout(() => {
        this.showDropDown = this.isAccountMenuHover ? true : false;
      }, 500);
      this.isAccountMenuHover = false;
    } else {
      this.showDropDown = isOpen;
      this.isAccountMenuHover = true;
    }
  }

  /**
   * Menu hover for the specific devices
   * @param isOpen
   */
  menuHover(isOpen: boolean, event: any, isJoinMenu?: boolean, isAboutMenu?: boolean) {
    if (this._commonService.isMobileDevice()) {
      return;
    } else {
      // when forceCollapse set true , it prevent mousehover default behaviour
      if (this.isForceCollapse) {
        event.preventDefault();
        this.isForceCollapse = false;
      } else if (isJoinMenu) {
        this.isJoinMenuCollapsed = isOpen;
      } else if (isAboutMenu) {
        this.isAboutMenuCollapsed = isOpen;
      } else {
        this.isCollapsed = isOpen;
      }
    }
  }
  minicartHover(isOpen: boolean) {
    if (this._commonService.isMobileDevice()) {
      return;
    } else {
      this.showMiniCart = isOpen;
    }
  }

  /**
  * @description logout from system
  * @memberof AppHeaderComponent
  */
  logout(): void {
    // clear keycloak cache
    if (this.userInfo && this.userInfo.distributorId) {
      this._commonService.clearKeyCloakCache(this.userInfo.distributorId)
        .subscribe((response: any) => {
          if (response) {
            this.logOutSettings();
          }
        }, error => {
          this.logOutSettings();
        });
    } else {
      this.logOutSettings();
    }
  }
  /**
  * logout from system
  * @returns void
  */
  logOutSettings(): void {
    const flp360LoginClicked = this._cacheService.get(CacheKey.Flp360LoginClicked);
    if (SSO.isRemoveObsoleteCookie()) {
      localStorage.removeItem(SSO.ACCESS_TOKEN);
      localStorage.removeItem(SSO.REFRESH_TOKEN);
      localStorage.removeItem(SSO.LOCAL_MEMBER_SESSION_ID);
      localStorage.removeItem(SSO.IS_NEW_TOKEN);
      this.cookieService.delete(SSO.MEMBER_SESSIONID, environment.cookiePath, environment.cookieDomain);
    } else {
      this.cookieService.delete(SSO.ACCESS_TOKEN, environment.cookiePath, environment.cookieDomain);
      this.cookieService.delete(SSO.REFRESH_TOKEN, environment.cookiePath, environment.cookieDomain);
    }
    this.cookieService.delete(SSO.MEMBER_SESSION_STATE, environment.cookiePath, environment.cookieDomain);
    this.cookieService.delete(SSO.NONCE, environment.cookiePath, environment.cookieDomain);
    this.cookieService.delete(SSO.MEMBER_ID, environment.cookiePath, environment.cookieDomain);
    this.cookieService.delete(CacheKey.hasCartItems, environment.cookiePath, environment.cookieDomain);
    this.cookieService.delete(SSO.MEMBER_SESSIONID, environment.cookiePath, environment.cookieDomain);
    // To notify other portals, the user has logged out
    //  this._cacheService.setCookieValue(CacheKey.loggedOut, true);
    // this._cacheService.remove(CacheKey.SSOToken);
    this._cacheService.remove(CacheKey.UserInfo);
    this._cacheService.remove(CacheKey.CartSessionInfo);
    this._cacheService.remove(CacheKey.WishListSession);
    this._cacheService.removeCookieValue(CacheKey.CartSessionGuid);
    this._cacheService.remove(CacheKey.CartItems);
    this._cacheService.remove(CacheKey.MyActionCenterModalDisplayed);
    this._cacheService.remove(SSO.MEMBER_SESSIONID);
    this._cacheService.remove(SSO.IS_NEW_TOKEN);
    this._cacheService.remove(CacheKey.MemberDiscountPercentage);
    this._cacheService.remove(CacheKey.CountryMetaData);
    this.cookieService.delete(CacheKey.FPCWholesaleQualified, environment.cookiePath, environment.cookieDomain);
    this._cacheService.removeSessionValue(CacheKey.fboId);
    let redirectUri: string;
    if ((this._router.url.split('/').indexOf('ordersummary') > -1) || (this._router.url.split('/').indexOf('checkout') > -1)) {
      this._cacheService.set(CacheKey.Nav_path, this.isoCountryCode + '/checkoutLogin');
      redirectUri = window.location.origin + '/' + this.isoCountryCode.toLowerCase() + '/checkoutLogin';
    }
    this._cacheService.remove(CacheKey.Flp360LoginClicked);
    const redirectUrl = flp360LoginClicked ? environment.flp360LoginUrl : environment.corporateUrl;
    window.location.href = decodeURIComponent(encodeURIComponent(SSO.getSSOLogoutUrl(redirectUrl)));
  }
  /**
   *  notify When country or language changes in the country language component
   * @param  {any} selectedCountryLanguage
   * @returns void
   */
  notifyCountryLanguageChange(selectedCountryLanguage: any): void {
    if (selectedCountryLanguage) {
      this.isoCountryCode = selectedCountryLanguage.countryCode;
      this.selectedLanguage = selectedCountryLanguage.languageCode;
      this.selectedCountry = selectedCountryLanguage.selectedCountry;
      this.selectedLanguageName = selectedCountryLanguage.selectedLanguageName;
    }
  }
  /**
   * Toggle hamburger menu items based upon the item property
   * @param  {string} item
   * @returns void
   */
  toggleHamburgerItem(item: string): void {
    const excludedItems = ['fboportal', 'myAccount'];
    if (excludedItems.indexOf(item) === -1) {
      const country = this.getPortalCountry();
      const countryURLMetaData: CountryUrlMetaData = country && country.urlMetadata && country.urlMetadata.length ?
        country.urlMetadata.find(x => x.portal.toLowerCase() === item.toLowerCase()) : null;
      if (item !== HamburgerItemConstants.RETAILSITE && country && !country.titanPlatformEnabled && environment.allCountriesCorporateEnabled
        && item && ((countryURLMetaData && !countryURLMetaData.navigationMenu) || !countryURLMetaData)) {
        this.validateNonTitanCountryNavigation(country, item);
      }
      else if (this._reportOnlyCountryService.reportOnlyCountry(this.isoCountryCode) &&
        ((countryURLMetaData && !countryURLMetaData.navigationMenu) || (!countryURLMetaData))) {
        this.reportOnlyCountryNavigation(country, item);
      } else {
        this.toggleItem(item);
      }
    } else {
      this.toggleItem(item);
    }
  }

  toggleItem(item: string): void {
    const toggleStatus = this.hamburgerToggleItem[item];
    this.hamburgerToggleItem = {};
    this.hamburgerToggleItem[item] = !toggleStatus;
  }
  /**
   * Toggle hamburger Menu in Mobile
   * @returns void
   */
  toggleHamburgerMenu(): void {
    this.showMobileNav = !this.showMobileNav;
    this.isSplashScreenShown = false;
    this.setBodyFixed(this.showMobileNav);
  }
  /**
   * Open hamburger menu when
   * menu item clicked from outside of hamburger Menu
   * @param {boolean} open
   * @memberof AppHeaderComponent
   */
  openHamburger(open: boolean): void {
    if (open) {
      this.toggleHamburgerMenu();
      this.hamburgerToggleItem['fboportal'] = true;
    }
  }
  /**
   * Show country language selector in mobile
   * @returns void
   */
  showCountryLanguageSelector(): void {
    this.showMobileNav = false;
    this.setBodyFixed(this.showMobileNav);
    this.isSplashScreenShown = true;
    this._dataService.setSplashScreenFlag(true);
  }

  /**
   * Navigate to the specific portal
   * @param portal
   * @param canRedirect
   */
  gotoModule(portal: string, canRedirect?: boolean): void {
    let redirectUrl;
    if (portal === 'join') {
      // if (this.loggedInUser) {
      //   if ((this.loggedInUser.memberTypeId !== MemberType.RETAILCUSTOMER)
      //   || (this.loggedInUser.memberTypeId !== MemberType.GUESTCUSTOMER)) {
      //       return;
      //   }
      // }
      redirectUrl = environment.enrollSiteURL + '/' + this.isoCountryCode.toLowerCase() + '/'
        + this.languageCode.toLowerCase() + '/welcome';
      redirectUrl = this._commonService.appendFBOID(redirectUrl);
      window.location.href = redirectUrl;
    } else if (portal === 'shop') {
      const shoppingCart: Cart = this._cacheService.get(CacheKey.CartSessionInfo);
      redirectUrl = environment.shopURL
        + '/' + this.isoCountryCode.toLowerCase() + '/' + this.languageCode.toLowerCase() + '/cart'; // redirect to cart has any cart items
      redirectUrl = this._commonService.appendFBOID(redirectUrl);
      if (shoppingCart && shoppingCart.itemsCount > 0 && shoppingCart.sessionGuid && !this.userInfo) {
        redirectUrl = redirectUrl;
      } else {
        canRedirect = false;
      }
      if (canRedirect) {
        window.open(redirectUrl, '_self');
      }
      window.location.href = redirectUrl;
    }
  }

  /**
  * navigate to wishlist screen
  */
  navigateToWishlist(isMobile?: boolean): void {
    if (!this.userInfo) {
      if (isMobile) {
        const cookieBannerData: CookieBannerResponse = {
          title: null,
          timeout: false,
          time: 2000,
          description: 'Please Login to add products to your favorites.',
          notificationType: CookieBannerType.CartItemNotification,
          notificationMessageType: CookieBannerMessageType.Favourites,
          showBanner: true
        };
        this._appMessageService.setCookieBannerData(cookieBannerData);
      }
    } else {
      let shopUrl = environment.shopURL + '/'
        + this.isoCountryCode.toLowerCase() + '/' + this.languageCode.toLowerCase() + '/favorite';
      shopUrl = this._commonService.appendFBOID(shopUrl);
      window.location.href = shopUrl;
    }
  }

  wishlistLogin(): void {
    this._cacheService.set(CacheKey.RedirectToFavourites, true);
    this.accountlogin();
  }
  /**
   * User Logged in info
   */
  accountlogin() {
    this._commonService.updateCountryCodeinCookie();
    const countryURLMetaData: CountryUrlMetaData = this.selectedPortalCountry && this.selectedPortalCountry.urlMetadata
      && this.selectedPortalCountry.urlMetadata.length ?
      this.selectedPortalCountry.urlMetadata.find(x => x.portal.toLowerCase() === HamburgerItemConstants.LOGIN.toLowerCase()) : null;
    if (this.selectedPortalCountry && !this.selectedPortalCountry.titanPlatformEnabled && environment.allCountriesCorporateEnabled
      && ((countryURLMetaData && !countryURLMetaData.navigationMenu) || !countryURLMetaData)) {
      this.validateNonTitanCountryNavigation(this.selectedPortalCountry, HamburgerItemConstants.LOGIN);
    } else if (!this.loggedIN) {
      this.login();
    } else {
      this.navigateToMyAccount();
    }
  }

  /** Toggle mini cart view */
  toggleMiniCart() {
    const cartSession: Cart = this._cacheService.get(CacheKey.CartSessionInfo);
    if (this.userInfo && this.userInfo.memberTypeId !== MemberType.RETAILCUSTOMER
      && (!cartSession || (cartSession && cartSession.items && cartSession.items.length === 0))) {
      let shopUrl = environment.shopURL + '/' + this.isoCountryCode.toLowerCase() + '/'
        + this.languageCode.toLowerCase() + '/cart';
      shopUrl = this._commonService.appendFBOID(shopUrl);
      window.location.href = shopUrl;
    } else {
      this.showMiniCart = !this.showMiniCart;
    }
  }

  /**
   * toggle header menu in mobile view
   */
  // showHeaderMenu() {
  //   this.showMenu = !this.showMenu;
  // }

  navigateTo(url: string) {
    this.router.navigate(['./' + this.isoCountryCode.toLowerCase() + '/' + url]);
  }

  /**
    * @description
    * @date 2018-10-01
    * @param {string} route
    * @memberof AppHeaderComponent
    */
  navigateToCorporate(route: string): void {
    this.router.navigate(['./' + this.isoCountryCode.toLowerCase()
      + '/' + this.languageCode.toLowerCase() + '/' + route]);
  }

  /**
   * To Destroy
   * @returns void
   */
  ngOnDestroy(): void {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }
    if (this.isCollapsedSubscription) {
      this.isCollapsedSubscription.unsubscribe();
    }
    if (this.wishListSubscription) {
      this.wishListSubscription.unsubscribe();
    }
  }
  /**
   * to navigate to My account page
   */
  navigateToMyAccount(): void {
    if (this._cacheService.get(CacheKey.CountryMetaData)) {
      this._commonService.updateCountryCodeinCookie();
    }
    const languageCode: string = this._cacheService.getCookieValue(CacheKey.languageCode);
    let accountUrl = environment.accountSiteURL + '/' + this.isoCountryCode + '/' + languageCode +
      '/account/my-profile';
    accountUrl = this._commonService.appendFBOID(accountUrl);
    window.location.href = accountUrl;
  }

  isMobileDevice(): boolean {
    return this._commonService.isMobileDevice();
  }



  /**
   * @description Internal Link which is not having a CMS content
   * @param  {any} menuItem
   * @returns void
   */
  accountProfileMenuClicked(memberAllowedResource: MemberAllowedResources): void {
    if (memberAllowedResource && memberAllowedResource.resourceUrl && !memberAllowedResource.showLink) {
      window.location.href = memberAllowedResource.resourceUrl;
    }
  }

  /**
   * @description hideFBO details card
   * @memberof AppHeaderComponent
   */
  showFBODetailCard(): void {
    this.showMyRetailSite = !this.showMyRetailSite;
  }

  /**
   * @description hideFBO details card
   * @memberof AppHeaderComponent
   */
  hideFBODetailCard() {
    this.showShareFBODetail = false;
  }

  /**toggle fbo card view */
  toggleShareFBOCard() {
    this.showShareFBODetail = !this.showShareFBODetail;
  }

  /**
  * Get Member information by distributor id
  *
  * @memberof AppHeaderComponent
  */
  getMemberDetails(): void {
    this._commonService.getMemberSpecificDetails(this.shareFBOID, SharedConstants.MEMBER_DETAIL_PROPERTIES)
      .subscribe(response => {
        if (response && response.fboId) {
          this.memberInformation = response;
          this.saveSharedFBODetails();
          this.searchSponsorWizardByFboId(this.shareFBOID, response);
        } else {
          this.searchSponsorWizardByFboId(this.shareFBOID);
        }
        window.history.pushState(null, null, window.location.pathname);
      }, (error: any) => {
        this.searchSponsorWizardByFboId(this.shareFBOID);
      });
  }


  /**
    * Remove Share fbo details
    *
    * @memberof AppHeaderComponent
    */
  removeShareFBODetails(): void {
    this.removeMyRetailSite = true;
    this.memberInformation = null;
    this.showTopMenu = false;
  }


  /**
   * @description
   * @date 2019-07-05
   * @private
   * @memberof AppHeaderComponent
   */
  private saveSharedFBODetails(): void {
    this._cacheService.set(CacheKey.ShareFBODetails, this.memberInformation);
    //  setTimeout(() => {
    this.showShareFBODetail = true;
    this.showTopMenu = true;
    this.removeMyRetailSite = false;
    //  }, 3000);
  }

  /**
   * searchSponsorWizardByFboId used to prepare request for Search By FBO ID or Email
   * @param  {string} FboId?
   * @returns void
   */
  searchSponsorWizardByFboId(fboId: string , memberInfo?: Member): void {
    fboId = fboId.indexOf('@') > -1 ? fboId : fboId.split('-').join('');
    const sponsorSearchRequest: SponsorSearchRequest = {
      UserName: fboId.indexOf('@') > -1 ? '' : fboId.trim(),
      Email: fboId.indexOf('@') > -1 ? fboId.trim() : '',
      FirstName: '',
      LastName: '',
      CountryId: '',
      PreferenceValue: '',
      PostalCode: '',
      StateId: '',
      City: '',
      Option: SponsorSearchOption.SearchByIKnowSponsor,
      EnableLongPoll: environment.enableLongPoll
    };
    this.getSponsorInformation(sponsorSearchRequest, SponsorSearchOption.SearchByIKnowSponsor, memberInfo);
  }


  /**
  * getSponsorInformation used to fetch sponsors from service
  * @param  {any} sponsorSearchRequest
  * @param  {number} option?
  * @returns void
  */
  getSponsorInformation(sponsorSearchRequest: SponsorSearchRequest, searchOption?: number, memberInfo?: Member): void {
    this.sponsorPollCount = 0;
    this._commonService
      .searchSponsors(sponsorSearchRequest)
      .subscribe((sponsorSearchResponse: SponsorSearchResponse) => {
        if (sponsorSearchResponse.requestStatus === ResponseStatus.COMPLETED) {
          this.processSearchSponsorResponse(sponsorSearchResponse, memberInfo);
        } else if (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED ||
          sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
          this.searchSponsorByPolling(sponsorSearchResponse, searchOption, memberInfo);
        } else {
          this.searchSponsorErrorResponse();
        }
      }, (error) => {
        this.searchSponsorErrorResponse();
      });
  }

  /**
   * @description we will load sponsor by pooling mechanism
   * @date 2019-03-18
   * @private
   * @param {SponsorSearchRequest} sponsorSearchRequest
   * @param {number} [searchOption]
   * @memberof SponsorSelectionComponentNew
   */
  private searchSponsorByPolling(
    searchResponse: SponsorSearchResponse, searchOption?: number, memberInfo?: Member): void {
    this._commonService
      .getSearchSponsorsByUUID(searchResponse)
      .subscribe((sponsorSearchResponse: SponsorSearchResponse) => {
        if (sponsorSearchResponse) {
          if (this.sponsorPollCount < this.sponsorMaxPollCount) {
            this.sponsorPollCount = this.sponsorPollCount + 1;
            if (sponsorSearchResponse.requestStatus === ResponseStatus.COMPLETED) {
              this.processSearchSponsorResponse(sponsorSearchResponse, memberInfo);
            } else if (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED ||
              sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
              this.searchSponsorByPolling(sponsorSearchResponse, searchOption, memberInfo);
            } else {
              this.searchSponsorErrorResponse();
            }
          } else {
            this.searchSponsorErrorResponse();
          }
        }
      }, (error) => {
        this.searchSponsorErrorResponse();
      });
  }

  /**
   * @description this method will process the search sponsor response
   * @date 2018-08-17
   * @private
   * @param {SponsorSearchResponse} sponsorSearchResponse
   * @param {number} [searchOption]
   * @returns {void}
   * @memberof SponsorSelectionComponentNew
   */
  private processSearchSponsorResponse(sponsorSearchResponse: SponsorSearchResponse, memberInfo?: Member): void {
    if (sponsorSearchResponse.sponsorSearchResultModels
      && sponsorSearchResponse.sponsorSearchResultModels.length > 0) {
      const sponsorModel = sponsorSearchResponse.sponsorSearchResultModels[0];
      if (sponsorModel && sponsorModel.sponsorId && !memberInfo) {
        this.memberInformation = this.mapSponsorToMember(sponsorSearchResponse.sponsorSearchResultModels[0]);
        this.saveSharedFBODetails();
      }
    }
  }

  private mapSponsorToMember(sponsorModel: SponsorInformation): Member {
    const member: Member = {
      userEntityId: null,
      fullName: sponsorModel.sponsorName,
      userName: null,
      firstName: sponsorModel.sponsorFirstName,
      lastName: sponsorModel.sponsorLastName,
      email: sponsorModel.sponsorEmail,
      userId: null,
      phone: sponsorModel.sponsorPhone,
      sponsorId: null,
      middleName: sponsorModel.sponsorMiddleName,
      userType: null,
      memberType: null,
      memberId: null,
      memberTypeId: null,
      distributorId: sponsorModel.sponsorId,
      profileImageURL: null,
      memberTitleId: null,
      memberTitle: null,
      homeCountryId: sponsorModel.sponsorCountryId,
      homeCountryCode: sponsorModel.sponsorCountryCode,
      memberAllowedCountries: null,
      wholesaleQualified: sponsorModel.wholesaleQualified,
      preferenceValue: sponsorModel.sponsorLanguageCode,
      displayName: sponsorModel.sponsorName,
      memberPreferences: null,
      fboId: sponsorModel.sponsorId
    };
    return member;
  }

  /**
   * @description this method will load when we got error in
   * sponsor search response
   * @date 2018-08-17
   * @private
   * @memberof SponsorSelectionComponentNew
   */
  private searchSponsorErrorResponse(): void {
    this.removeMyRetailSite = true;
    this.shareFBOID = null;
    this._cacheService.remove(CacheKey.ShareFBODetails);
    this._cacheService.removeSessionValue(CacheKey.fboId);
    this.memberInformation = null;
    const message: any = this._translatePipe.instant('common.Sponsor not found');
    this._notificationService.createNotification('', message, NotificationType.ERROR);
  }

  /**
     * @description get country contact information based on map location
     * @date 2019-11-11
     * @memberof AppHeaderComponent
     */
  getMapLocation(): void {
    const homeCoutryCode = this.storeData && this.storeData.operatingCountry;
    this._commonService.getMapLocations().subscribe((response: MapLocationInfo[]) => {
      this.mapLocation = response.find(item => item.countryCode === homeCoutryCode);
    });
  }
}
